export enum QuoteStatus {
  Pending,   //Before attempting Quote request.
  Loading,   //Getting quote in progress
  Successful,//Good Quote
  Failed,  //Quote was not successful
  Invalid  //Invalid Country or State
}
